<template>
  <BootstrapModal
    ref="modal"
    modalId="deleteUserModal"
    title="Confirm Deletion"
    closeText="No"
    confirmText="Yes, Delete"
    isDeleteConfirmation
    :deleteMessage="deleteMessage"
    @confirm="handleConfirm"
  />
</template>

<script>
import BootstrapModal from "@/components/Common/BootstrapModal.vue";
import userService from "@/services/userService.js";
import emitter from "@/eventBus";

export default {
  name: "DeleteUserModal",
  components: { BootstrapModal },
  props: {
    user: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ["deleted"],
  computed: {
    deleteMessage() {
      return this.user
        ? `Are you sure you want to delete user <b>"${this.user.name}"</b>?<br> 
            <span class="text-secondary small">This action is irreversible and cannot be undone. Please proceed with caution.</span>`
        : "Are you sure you want to delete this user? This action is irreversible.";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async handleConfirm() {
      if (!this.user?.id) return;

      try {
        await userService.deleteUser(this.user.id);
        emitter.emit("show-toast", {
          message: `User "${this.user.name}" deleted successfully.`,
          type: "success",
        });
        this.$emit("deleted", this.user.id);
      } catch (error) {
        console.error(error);
      }

      this.hide();
    },
  },
};
</script>
